import { ITjipDatepickerOptions } from '@tjip/vuejs';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { minLength, required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { IRegistreerRequest } from '@/model/IRegistreerRequest';
import { appRegistrerenService } from '@/services/appRegistrerenService';
import { authService } from '@/services/AuthService';
import { tjipBusyService } from '@/services/tjipBusyService';
import { tjipWindowService } from '@/services/tjipWindowService';

@Component({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  validations: AppRegistreren.validations
})
export default class AppRegistreren extends Vue {
  private static validations(this: AppRegistreren) {
    return {
      data: {
        geboortedatum: {
          required
        },
        hypotheeknummer: {
          required,
          minLength: minLength(5)
        },
        ibandeel: {
          required,
          minLength: minLength(4)
        },
        geheim: {
          required,
          minLength: minLength(12)
        }
      }
    };
  }

  @State(state => state.config.authBaseUri)
  public authBaseUri!: string;
  @Action('logout')
  private logout!: () => void;
  public showError = false;

  public data: IRegistreerRequest = {
    geboortedatum: undefined,
    hypotheeknummer: undefined,
    ibandeel: undefined,
    geheim: undefined,
    token: undefined
  };

  public get twoDigitBaseYear(): number {
    return moment()
      .add(-100, 'year')
      .year();
  }

  public submit(): void {
    this.data.token = this.$route.query.token as string;
    tjipBusyService.add(
      appRegistrerenService.registreer(this.data).then((success: boolean) => {
        if (success) {
          this.showError = false;
          return tjipWindowService.changeHref(`${this.authBaseUri}/continue?state=${this.$route.query.state}`);
        } else {
          this.showError = true;
        }
      })
    );
  }

  public cancel() {
    this.logout();
    authService.logout();
  }

  public get datepicker(): ITjipDatepickerOptions {
    return {
      initialView: 'year',
      openDate: moment()
        .subtract(35, 'year')
        .toDate()
    };
  }
}
